import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Space, Typography } from 'antd'

import { getShopifyBaseUrl } from 'src/utils/helper'

const ShopSection = (): ReactElement => {
  const { t } = useTranslation()
  const baseUrlShopify = getShopifyBaseUrl()
  return (
    <Space direction="vertical">
      <Typography.Title level={3}>
        {t('common:footer.sections.shop')}
      </Typography.Title>
      <a href={`${baseUrlShopify}/collections/eyeglasses`}>
        {t('common:footer.shop.glasses')}
      </a>
      <a href={`${baseUrlShopify}/collections/accessories`}>
        {t('common:footer.shop.accessories_giftcard')}
      </a>
    </Space>
  )
}

export default ShopSection
